import ApiService from './ApiService';
import UrlService from './UrlService';

const getPredefinedLocationAssets = (companyId, pagination, filter) => (
  ApiService.defaultInstance.post(UrlService.predefinedLocationAssets(companyId), {
    pagination: {
      page: pagination.page,
      size: pagination.size,
    },
    ...(filter ? { filter } : {}),
  })
);

const getPredefinedLocationExists = (companyId) => (
  ApiService.defaultInstance.get(UrlService.predefinedLocationExists(companyId))
);

const getPredefinedLocationAssetsSummary = (companyId) => (
  ApiService.defaultInstance.get(UrlService.predefinedLocationAssetsSummary(companyId))
);

export default {
  getPredefinedLocationAssets,
  getPredefinedLocationExists,
  getPredefinedLocations: (companyId) => (
    ApiService.defaultInstance.get(UrlService.predefinedLocations(companyId))
  ),
  getPredefinedLocationAssetsSummary,
};
